var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyServiceVisits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    height: "2.22rem",
    width: "2.22rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_Service__Visits",
    "data-name": "My_Service_Visits"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6,44.73H2.19V13.63H46.9V25.29a1,1,0,0,0,1.94,0V3.91a1,1,0,0,0-1-1H37.67V1a1,1,0,0,0-2,0v2H25.52V1a1,1,0,0,0-1.95,0v2H13.37V1a1,1,0,0,0-1.94,0v2H1.22a1,1,0,0,0-1,1V45.7a1,1,0,0,0,1,1H22.6a1,1,0,1,0,0-1.94ZM11.43,4.88v2a1,1,0,1,0,1.94,0V4.88h10.2v2a1,1,0,0,0,1.95,0V4.88h10.2v2a1,1,0,0,0,2,0V4.88H46.9v6.81H2.19V4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.39,35.47l-2.24-.67a11.18,11.18,0,0,0-.86-2.1l1.12-2.1a.55.55,0,0,0-.1-.61L45,27.68a.55.55,0,0,0-.38-.16.46.46,0,0,0-.23.06L42.31,28.7a10.61,10.61,0,0,0-2.09-.87l-.66-2.25a1,1,0,0,0-.56-.26H35.79a.61.61,0,0,0-.51.36l-.66,2.25a10.9,10.9,0,0,0-2.09.88l-2.09-1.13a.6.6,0,0,0-.23-.06.55.55,0,0,0-.38.16l-2.24,2.31a.53.53,0,0,0-.1.61l1.12,2.1a11,11,0,0,0-.87,2.11l-2.24.61a.5.5,0,0,0-.36.46v3.23a.64.64,0,0,0,.36.52l2.24.66a10.69,10.69,0,0,0,.87,2.1L27.49,44.6a.53.53,0,0,0,.1.61l2.29,2.31a.54.54,0,0,0,.38.15.46.46,0,0,0,.23-.05l2.09-1.13a10.26,10.26,0,0,0,2.09.87l.66,2.26a.52.52,0,0,0,.51.36h3.21a.61.61,0,0,0,.51-.36l.66-2.26a10,10,0,0,0,2.09-.87l2.09,1.13a.46.46,0,0,0,.23.05.54.54,0,0,0,.38-.15l2.3-2.31a.55.55,0,0,0,.1-.61l-1.12-2.11a10.66,10.66,0,0,0,.86-2.1l2.24-.66a.52.52,0,0,0,.36-.52V36A.61.61,0,0,0,49.39,35.47ZM43,37.65a5.5,5.5,0,1,1-5.5-5.53A5.52,5.52,0,0,1,43,37.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.05,17.5a1,1,0,0,0-1-1h-5a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1Zm-1.95,4h-3v-3h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,16.53a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1v-5a1,1,0,0,0-1-1Zm4,5H28v-3h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.89,16.53a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1v-5a1,1,0,0,0-1-1Zm4,5h-3v-3h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.15,27.53a1,1,0,0,0-1-1h-5a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1Zm-2,4h-3v-3h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.05,27.53a1,1,0,0,0-1-1h-5a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1Zm-1.95,4h-3v-3h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.17,35.54h-5a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1v-5A1,1,0,0,0,12.17,35.54Zm-1,5h-3v-3h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.07,35.54h-5a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1v-5A1,1,0,0,0,22.07,35.54Zm-1,5h-3v-3h3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyServiceVisits);
export default __webpack_public_path__ + "static/media/MyServiceVisits.5af0ed97.svg";
export { ForwardRef as ReactComponent };